import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { ChartColorsPipe } from './pipes/chart-color.pipe'
@NgModule({
  imports: [CommonModule],
  declarations: [ChartColorsPipe],
  exports: [ChartColorsPipe],
})
export class ChartUtilitiesModule {}
